import { Helpers } from '../helpers';

export const CartAPI = function(apiConfig, http){
  let self = this;

  function setParamOptions(addCartParams, options){
    let params = Object.assign({}, addCartParams);
    const onErr = () => {
      throw 'Invalid options information provided to addToCart';
    }

    if(!Object.keys(options).length){
      return params;
    }

    if(options.isGC){
       const {
        confirmEmail,
        recipientEmail,
        toName,
        fromName,
        message,
        type,
        itemId,
        price
       } = options;


       if(!itemId || !fromName || !toName){
        onErr()
       }

        params.isGC = options.isGC;
        params.gcPrice=price;
        params.gcMessage= message;
        params.gcToName=toName;
        params.gcFromName=fromName;
        params.gcType=type;
        params.gcPartNumber=itemId;
        params.catEntryId = itemId;

       if(type === 'VGC'){
        (!confirmEmail || !recipientEmail || confirmEmail !== recipientEmail) && onErr();
        params.gcMail = recipientEmail;
       }

    } else if (options.eCarepack.length) {
      const { eCarepack } = options;

      eCarepack.forEach( ec => {
        const { elgblSku } = ec;
        let { index } = ec;
     /*   if(++index){
          params[`elgblSKU_${index}`] = elgblSku;
        } else {
          params[`elgblSKU`] = elgblSku;
        }*/

        //AddToCart service doesn't support _INDEX sytax for elgblSku
        //These means there could be a case where multiple eCarepacks are in add to cart
        //With different elgigble sku IDs. In this case they will all get associated with the same hardware sku
        //One thing we could do is if we see multiple with different hardware skus we could break them out in their own add to cart call
        //before making the multi sku add. But for now we will just ignore this
        params[`elgblSku`] = elgblSku;
      });

    } else {
      // remove extra param
      delete options.eCarepack;
      Object.assign(params, options);
    }

    return params;
  }

 /**
 * [addToCart adds one or more products to cart]
 * @param {[String or Object]} product [Accepts either a string itemId or array of ids]
 * @param {[Number]} qty [The quantity for the itemId provided in the first argument]
 * @param {[Object]} options [meta options to be passed into add to cart function]
 * @return {[Promise]} [Promise from the http request]
 */
  self.addToCart = (id, qty, options) => {
    var params = Object.assign({
      calculationUsage: '-1%2C-2%2C-5%2C-6%2C-7', //need to see if these changes if logged in
      inventoryValidation: "true",
      URL: "", //need to see if these changes if logged in
      updatePrices: 1, //need to see if these changes if logged in
      isGC: "N", //need to see if these changes if logged in
      requesttype: 'ajax',
      orderId: "."
    },apiConfig.siteInfo);
    //if null or undefined is explicetly passed into qty
    qty = qty || 1;

    //if array of only one item, convert to single addToCat
    id = id && id.constructor === Array && id.length === 1 ? id[0] : id;
    qty = qty &&  qty.constructor === Array && qty.length === 1 ? qty[0] : qty;
    
    if(id && id.constructor === Array){
        const ids = id;
        ids.forEach((itemId, i) => {
          params[`catEntryId_${i + 1}`] = itemId;
          params[`quantity_${i + 1}`] = qty && qty.constructor === Array ? qty[i] : qty;
        });
    }else{
      params.catEntryId = id;
      params.quantity = qty;
    }

    try{
      if(options){
        params = setParamOptions(params, options);
      }
      
      return http.post("AddToCartAjax",Helpers.parseFormData(params));
    }catch(e){
      console.error(e);
      return Promise.reject(e);
    }
  };
  
  self.updateCartItem = (orderItemId, qty) => {
    //include site params with add to cart specific params
    var params = Object.assign({
      orderId:".", //need to see if these changes if logged in
      orderItemId: orderItemId,
      inventoryValidation:"true",
      quantity: qty,
      calculationUsage:"-1%2C-2%2C-3%2C-4%2C-5%2C-6%2C-7", //need to see if these changes if logged in
      check:"*n", //need to see if these changes if logged in
      requesttype:"ajax"
    },apiConfig.siteInfo);

    return http.post("AjaxOrderChangeServiceItemUpdate",Helpers.parseFormData(params));
  }

  self.deleteCartItem = (orderItemId) => {
    var params = Object.assign({
      orderId:".", //need to see if these changes if logged in
      orderItemId: orderItemId,
      inventoryValidation:"true",
      calculationUsage:"-1%2C-2%2C-3%2C-4%2C-5%2C-6%2C-7", //need to see if these changes if logged in
      check:"*n", //need to see if these changes if logged in
      requesttype:"ajax"
    },apiConfig.siteInfo);

    return http.post("AjaxOrderChangeServiceItemDelete",Helpers.parseFormData(params));
  }

  self.getCTOPrice = (catentryId, skus, usertype='', crossSell='', pStoreId='', currentDate) => {
        const params = {
            storeId: apiConfig.siteInfo.storeId,
            usertype,
            catentryId,
            skus: skus.join(","),
            crossSell,
            pStoreId,
            currentDate: currentDate || Helpers.date.etrDateFormat(new Date())
        };
        return http.get(`PriceStrikeThroughDynamicKitDisplayCmd`, { params })
            .then(resp => {
                const { data, status } = resp;
                //attempt to parse response
                if (status === 200 && data && data !== '') {
                    return data;
                } else {
                    return Promise.reject({})
                }
            });
    }
};
